import React, { lazy } from "react";

import { SettingsTabbedContent } from "../SettingsTabbedContent";

const EditProfileFormTab = lazy(() => import("./EditProfileForm/EditProfileForm"));
const ChangePasswordTab = lazy(() => import("./ChangePasswordForm/ChangePasswordForm"));

const tabs = [
  { label: "Details", path: "details", component: EditProfileFormTab },
  { label: "Change Password", path: "change-password", component: ChangePasswordTab },
];

const UserProfile: React.FC = () => {
  return <SettingsTabbedContent prefix="/settings/profile" tabs={tabs} data-testid="user-profile" />;
};

export default UserProfile;
